"use client";

import { useComboboxContext } from "../__chunks/VEVQD5MH.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-value.tsx
import { invariant } from "@ariakit/core/utils/misc";
function ComboboxValue() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    store = _ref.store,
    children = _ref.children;
  var context = useComboboxContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "ComboboxValue must receive a `store` prop or be wrapped in a ComboboxProvider component.");
  var value = store.useState("value");
  if (children) {
    return children(value);
  }
  return value;
}
export { ComboboxValue };